import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    height: 56,
    minWidth: 140,
    borderRadius: 16,
    '& + &': {
      marginLeft: 8,
    },
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    overflow: 'hidden',
  },
  labelsContainer: {
    height: 48,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 18,
  },
  valueContainer: {
    height: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 12,
    fontWeight: 700,
    textAlign: 'center',
    margin: 0,
  },
  value: {
    // marginTop: -4,
    fontSize: 30,
    fontWeight: 700,
    textAlign: 'center',
    margin: 0,
  },
}));
